/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import Loading from '../../components/loading/loading.component';
import DocumentsService from './documents.service';
import PropTypes from 'prop-types';
import * as consts from '../../const';
import Notification from '../common/notification/notification.component';
import DetailedTitledPage from '../../router/pages/detailed.titled.page';
import { Button, Clearfix } from 'react-bootstrap';
import { ADD_DOCUMENT } from '../../const';

const finalStatuses = ['ABORTED', 'STUDY_TERMINATED', 'STUDY_COMPLETED', 'WITHDRAWN_CONSENT', 'FAILED_SCREENING'];
class Documents extends React.Component {
  componentWillUnmount() {
    // component specific data is kept in the redux store
    // because of this anti-pattern, when the component initializes, it displays previously saved documents
    // causing bad UX and confusing behaviour in tests (if new documents are received with latency)
    // to fix this thoroughly, we'll have to refactor the affected modules
    this.props.clearDocuments();
  }

  showPdf(consentId, consentingId, isSigned, consentName, addendumId) {
    this.props.fetchPdf(consentId, consentingId, isSigned, consentName, addendumId);
  }

  getLastConsentingGid(documents) {
    if (!documents) return null;
    const withConsenting = documents.filter((d) => d.consentingGid !== null);
    if (withConsenting.length === 0) return null;
    if (withConsenting.length === 1) return withConsenting[0].consentingGid;
    withConsenting.sort(
      (a, b) => new Date(b.timestamp || b.signedTimestamp || 0) - new Date(a.timestamp || a.signedTimestamp || 0)
    );
    return withConsenting[0].consentingGid;
  }

  render() {
    let body;
    let notification = '';
    if (this.props.error) {
      notification = <Notification type="error" data={this.props.error} />;
    }
    if (this.props.isFetching || (!this.props.documents && !this.props.error)) {
      body = <Loading />;
    } else {
      let lastConsentingGid = this.getLastConsentingGid(this.props.documents);
      const participantDocumentActionsAllowed =
        this.props.participant && finalStatuses.indexOf(this.props.participant.overallStatus) < 0;
      const visible = participantDocumentActionsAllowed ? 'show' : 'hide';
      let grids = DocumentsService.prepareData(
        this.props.documents,
        this.props.participant,
        {
          createNewNote: this.props.createNewNote,
          showPdfIframe: this.showPdf.bind(this),
          editDocumentStatus: this.props.editDocumentStatus,
          changeAnswers: this.props.changeAnswers,
          showJournal: this.props.showJournal,
          generatePdf: this.props.generatePdf,
          uploadPdf: this.props.uploadPdf,
          showError: this.props.showError,
          deleteDocument: this.props.deleteDocument,
          deleteAddendum: this.props.deleteAddendum({
            studyGid: this.props.participant.studyGid,
            participantId: this.props.participant.userId
          })
        },
        this.props.reporter,
        participantDocumentActionsAllowed,
        this.props.timezone
      );

      body = (
        <div>
          {notification}
          <div>
            <div>
              <h4 className="pending-label">{consts.ASSIGNED_DOCUMENTS}</h4>
              <Button
                id="add-participant-document"
                bsClass="btn-link"
                className={`${visible} add-document-btn`}
                onClick={() => {
                  this.props.showAddNewDocumentModal(this.props.participant.gid, lastConsentingGid);
                }}
              >
                <i className="material-icons">add_circle_outline</i>
                {ADD_DOCUMENT}
              </Button>
              <Clearfix />
            </div>
            {grids.assigned}
            <h4>{consts.SIGNED_DOCUMENTS}</h4>
            {grids.signed}
            <div className="obsolete-grid">
              <h4>{consts.OBSOLETE_DOCUMENTS}</h4>
              {grids.obsolete}
            </div>
          </div>
        </div>
      );
    }

    let title = consts.DOCUMENTS_PAGE_TITLE;
    let details = consts.DOCUMENTS_DETAILS_TEXT;
    let content = <div id="documents-component">{body}</div>;

    return <DetailedTitledPage title={title} details={details} content={content} />;
  }
}

Documents.propTypes = {
  studyGid: PropTypes.string,
  participantId: PropTypes.number,
  isFetching: PropTypes.bool,
  documents: PropTypes.array,
  error: PropTypes.object,
  fetchDocuments: PropTypes.func,
  editDocumentStatus: PropTypes.func,
  fetchPdf: PropTypes.func,
  showAddNewDocumentModal: PropTypes.func,
  participant: PropTypes.object,
  showJournal: PropTypes.func,
  uploadPdf: PropTypes.func,
  createNewNote: PropTypes.func,
  showError: PropTypes.func,
  deleteDocument: PropTypes.func,
  reporter: PropTypes.object,
  clearDocuments: PropTypes.func,
  deleteAddendum: PropTypes.func,
  generatePdf: PropTypes.func
};

export default Documents;
